import { VignetteDTO } from '@app/src/views/StepTwo/channelPublication/dto/VignetteDTO';
import { VignetteModel } from '@app/src/views/StepTwo/channelPublication/models/vignette';

export const hydrateData = (data: VignetteDTO[]) =>
  data.map((item: VignetteDTO) => ({
    id: item.id,
    alias: item.alias,
    name: item.name,
    codeLabel: item.code_label
  } as VignetteModel));
